import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed top-0 inset-x-0 mx-2 sm:flex sm:items-top sm:justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "absolute h-screen w-full flex justify-center overflow-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modals-target" }, [
    _createVNode(_Transition, { "leave-active-class": "duration-200" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createVNode(_Transition, {
            "enter-active-class": "ease-out duration-300",
            "enter-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "ease-in duration-200",
            "leave-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: "fixed inset-0 transform transition-all",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, _hoisted_3, 512), [
                [_vShow, _ctx.show]
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_Transition, {
              "enter-active-class": "ease-out duration-300",
              "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
              "leave-active-class": "ease-in duration-200",
              "leave-class": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              onEnter: _ctx.shown
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                  class: _normalizeClass(["absolute my-6 bg-white rounded-lg shadow-xl transform transition-all sm:w-full", _ctx.maxWidthClass])
                }, [
                  _renderSlot(_ctx.$slots, "default", { close: _ctx.close })
                ], 2), [
                  [_vShow, _ctx.show]
                ])
              ]),
              _: 3
            }, 8, ["onEnter"])
          ])
        ], 512), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 3
    })
  ]))
}